module.exports = __webpack_public_path__ + "static/img/boothStep2.cf3ce301.jpg";